import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";


const useToaster = () => {
    const Swal = useSwalWrapper();

    return (variant, message) => {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
            showCloseButton: true
        });
        Toast.fire({
            icon: variant,
            title: message,
            background: "white"
        });
    };
};

export default useToaster;